import { render, staticRenderFns } from "./TabOrders.vue?vue&type=template&id=a7199762&scoped=true"
import script from "./TabOrders.vue?vue&type=script&lang=js"
export * from "./TabOrders.vue?vue&type=script&lang=js"
import style0 from "./TabOrders.vue?vue&type=style&index=0&id=a7199762&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7199762",
  null
  
)

export default component.exports